import { useApiClient } from '../client.js'

export const STRIPE_CONNECTION_TOKEN = '/core/v2/business_api/me/businesses/{businessId}/stripe/connection_token'

export function getStripeConnectionToken (businessId) {
  const apiClient = useApiClient()

  return apiClient.get({
    url: STRIPE_CONNECTION_TOKEN,
    urlParams: {
      businessId,
    },
  })
}
